// extracted by mini-css-extract-plugin
export default {"row":"classes_row__TAO6B","left":"classes_left__c5NWN","nftImage":"classes_nftImage__Tw2WJ","color":"classes_color__JYHem"};